import { ILoraCommand, ISensor } from "./ISensor";

export interface IDevice {
    id: string;
    ownerId: string;
    name: string;
    description: string;
    type: string;
    lastUplinkData?: string | null;
    lastUplinkDate?: number | null;
    metadata: { [key: string] : string };
    commands: ILoraCommand[];
    configuration: ILoraCommand[];
    sensors: ISensor[];
}

export enum DeviceSpecification {
    OTAA_1_0_x = "OTAA v1.1.x",
    OTAA_1_1 = "OTAA v1.1",
    ABP_1_0_x = "ABP v1.0.x",
    ABP_1_1 = "ABP v1.1"
}

export enum DeviceType {
    NestHub = "NestHub",
    SentriusRS1xx = "SentriusRS1xx"
}